import { Form, Input } from "antd";
import type { FormInstance } from "antd";
import { useTranslation } from "react-i18next";

import SelectTerritorialUnitsCode from "features/territorialUnit/ui/SelectTerritorialUnitsCode";
import styles from "./HandbookFormModal.module.css";

/**
 * Территориальная единица выбирается из внешнего справочника СОАТЕ,
 * а название, код и тип подставляются из неё и дальше только читаются.
 */
export const TerritorialUnitFields = ({ form }: { form: FormInstance }) => {
  const { t } = useTranslation();

  const handleChange = (value: any) => {
    const selectedArea = form.getFieldValue("area");
    const touchedType = form.isFieldTouched("type");

    form.setFieldsValue({
      territorialUnit: value
        ? {
            ...value,
            parentId: selectedArea?.id || value?.parent?.id || null,
            areaCode: selectedArea?.code || value?.areaCode || null,
          }
        : null,

      code: value.code,
      nameRu: value.nameRu,
      nameKy: value.nameKy,
      type: value?.type,
      ...(value?.type && !touchedType ? { type: value.type } : {}),
    });

    if (!value) {
      form.setFieldsValue({ code: "" });
    }
  };

  return (
    <>
      <Form.Item
        className={styles.formItem}
        label={t("map.territorialUnit")}
        name="territorialUnit"
        rules={[{ required: true, message: t("map.territorialUnit_msg") }]}
      >
        <SelectTerritorialUnitsCode
          areaCode={null}
          size="large"
          onChange={handleChange}
        />
      </Form.Item>

      <Form.Item name="type" label="Тип территориальной единицы">
        <Input readOnly />
      </Form.Item>

      <Form.Item name="code" label="СОАТЕ">
        <Input readOnly />
      </Form.Item>
    </>
  );
};
